import axios from "axios";
import { APP_URL } from "../../../config/api";
import { errorMessage } from "../../errorHandle";

export const createCertificationMaster = (cred) => {
  return (dispatch) => {
    dispatch({
      type: CERTIFICATION_MASTER.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/create-certification-master`,
        data: cred,
      })
      .then((res) => {
        dispatch({
          type: CERTIFICATION_MASTER.CERTIFICATION_MASTER_CREATE,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, CERTIFICATION_MASTER.ERROR));
      });
  };
};

export const certificationMasterList = (cred) => {
  return (dispatch) => {
    dispatch({
      type: CERTIFICATION_MASTER.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/certification-master-list`,
        data: cred,
      })
      .then((res) => {
        dispatch({
          type: CERTIFICATION_MASTER.CERTIFICATION_MASTER_LIST,
          payload: res.data.list,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, CERTIFICATION_MASTER.ERROR));
      });
  };
};

export const getCertificationMaster = (cred) => {
  return (dispatch) => {
    dispatch({
      type: CERTIFICATION_MASTER.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/get-certification-master`,
        data: cred,
      })
      .then((res) => {
        dispatch({
          type: CERTIFICATION_MASTER.CERTIFICATION_MASTER_GET,
          payload: res.data.list,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, CERTIFICATION_MASTER.ERROR));
      });
  };
};

export const updateCertificationMaster = (cred) => {
  return (dispatch) => {
    dispatch({
      type: CERTIFICATION_MASTER.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/update-certification-master`,
        data: cred,
      })
      .then((res) => {
        dispatch({
          type: CERTIFICATION_MASTER.CERTIFICATION_MASTER_UPDATE,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, CERTIFICATION_MASTER.ERROR));
      });
  };
};

const TAG = "CERTIFICATION_MASTER";
export const CERTIFICATION_MASTER = {
  ERROR: TAG + "ERROR",
  REQUEST: TAG + "REQUEST",
  CERTIFICATION_MASTER_CREATE: TAG + "CERTIFICATION_MASTER_CREATE",
  CERTIFICATION_MASTER_LIST: TAG + "CERTIFICATION_MASTER_LIST",
  CERTIFICATION_MASTER_GET: TAG + "CERTIFICATION_MASTER_GET",
  CERTIFICATION_MASTER_UPDATE: TAG + "CERTIFICATION_MASTER_UPDATE",
};
